import selfCardService from "@/apis/selfCard/index.js";

export default {
    methods: {
        // 向服务器端上传图片获取url
        uploadFileOss(file) {
            return new Promise((resolve) => {
                const fileInfo = {
					base64_str: file.content,
                    file_ext: file.file.name.split(".").pop(),
                }
                selfCardService.uploadFileOss({ ...fileInfo }).then((res) => {
                    resolve(res)
                }).catch((e) => {
                    console.log(e)
                    resolve(false)
                })
            })
        },
        // 把文件从 van-uploader 格式转换成后端 API 接收格式
        convertFilesToUploadFormat(files) {
            const fileList = [];
            if (files.length > 0) {
                files.forEach(item => {
                    const file = {
                        ref_id: 0,
                        file_path: item.url,
                        file_name: item.file.name,
                        file_ext: item.file.name.split(".").pop(),
                        file_size: item.file.size,
                        business_type: ''
                    }
                    fileList.push(file);
                })
            }
            return fileList;
        },
        // 把文件从 API 接收的文件转换成 van-uploader 格式
        convertFilesToVanUploaderFormat(files) {
            const fileList = [];
            if (files.length > 0) {
                files.forEach(item => {
                    const file = {
                        url: item.file_path,
                        file: new File([], item.file_name, {})
                    }
                    fileList.push(file);
                })
            }
            return fileList;
        },
        // 根据连接下载 Excel
        downloadFile(url) {
            const link = document.createElement('a');
            link.setAttribute('href', url);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        // 根据文件流下载 Excel
        downloadExcelByFileStream(fileName, data) {
            const currentDate = this.getCurrentDate()
            const link = document.createElement('a')
            const blob = new Blob([data], {
                type: 'application/vnd.ms-excel'
            })
            const url = window.URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', `${fileName}(${currentDate}).xlsx`)
            link.click()
        },
        /*  获取当天的日期  */
        getCurrentDate() {
            const date = new Date()
            const year = date.getFullYear()
            let month = date.getMonth() + 1
            month = month < 10 ? '0' + month : month
            let day = date.getDate()
            day = day < 10 ? '0' + day : day
            return year + '-' + month + '-' + day
        },
        forceUpdate() {
            this.$forceUpdate();
        },
    },
};
